import { render } from "./CreateGalery.vue?vue&type=template&id=3a77faf3&scoped=true"
import script from "./CreateGalery.vue?vue&type=script&lang=js"
export * from "./CreateGalery.vue?vue&type=script&lang=js"

import "./CreateGalery.vue?vue&type=style&index=0&id=3a77faf3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a77faf3"]])

export default __exports__